import { render, staticRenderFns } from "./americaOriginalExcel.vue?vue&type=template&id=0d21ab20&scoped=true&"
import script from "./americaOriginalExcel.vue?vue&type=script&lang=js&"
export * from "./americaOriginalExcel.vue?vue&type=script&lang=js&"
import style0 from "./americaOriginalExcel.vue?vue&type=style&index=0&id=0d21ab20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21ab20",
  null
  
)

export default component.exports